// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#greyscreen{width:100vw;height:100vh;z-index:1000;position:absolute;background-color:#383838;overflow-y:scroll}#greyscreen div,#greyscreen h1,#greyscreen h2,#greyscreen h3,#greyscreen p,#greyscreen strong{color:#fff}", ""]);
// Exports
module.exports = exports;
